import React, { useState } from "react";
import { Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Eye, EyeSlash } from "react-bootstrap-icons";

import { setCredentials } from "../slices/authSlice";
import FormContainer from "../components/FormContainer";
import Loader from "../components/Loader";
import { useAdminLoginMutation } from "../slices/AdminSilce";

const FoodAppLoginScreen = () => {
  const [mobileNumber, setMobileNumber] = useState();
  const [password, setPassword] = useState("");
  const [pwdVisible, setPwdVisible] = useState(false);

  const { userInfo } = useSelector((state) => state.auth);
  const [login, { isLoading }] = useAdminLoginMutation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    if (mobileNumber?.toString()?.length !== 10 || Number(mobileNumber) < 0)
      toast.warning("Please provide valid mobile number");
    else if (password?.length < 8 || password?.length > 50)
      toast.error("Mobile or Password is incorrect");
    else
      try {
        const res = await login({
          mobileNumber: mobileNumber,
          password: password,
        }).unwrap();
        dispatch(
          setCredentials({
            ...res,
          })
        );
        // navigate(redirect);
        navigate("/");
        toast.success("Successfully logged in ");
      } catch (err) {
        toast.error(err?.data?.error || err.error);
      }
  };

  const setPwdVisibility = () => {
    setPwdVisible(!pwdVisible);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "90vh",
      }}
    >
      <FormContainer>
        <Form onSubmit={submitHandler}>
          <Form.Group className="my-2" controlId="mobileNumber">
            <Form.Label id="mobileNumber">Mobile : </Form.Label>
            <Form.Control
              type="text"
              pattern="[0-9]*" // Allow only digits
              value={mobileNumber || ""}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                setMobileNumber(value);
              }}
              placeholder="mobile number"
            />
          </Form.Group>

          <Form.Group className="my-2" controlId="password">
            <Form.Label id="password">Password : </Form.Label>
            <div style={{ display: "flex" }}>
              <InputGroup>
                {" "}
                <Form.Control
                  type={pwdVisible ? "text" : "password"}
                  placeholder="enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <Button
                  className={`${
                    userInfo ? userInfo.themeColor : "cyan"
                  }ThemeHeaderTop`}
                  onClick={setPwdVisibility}
                >
                  {pwdVisible ? <Eye /> : <EyeSlash />}
                </Button>{" "}
              </InputGroup>
            </div>
          </Form.Group>
          <Form.Group className="my-2" style={{ marginLeft: "35%" }}>
            <Button
              className={`${
                userInfo ? userInfo.themeColor : "cyan"
              }ThemeHeaderTop`}
              type="submit"
              variant="primary"
            >
              Sign In
            </Button>
          </Form.Group>
          {isLoading && <Loader />}
        </Form>
        <Row className="py-3">
          <Col>
            <Link
              style={{ color: "white", marginLeft: "20%" }}
              to="/resetPassword"
            >
              Forgot Password ?
            </Link>
          </Col>
        </Row>
        <Row className="py-2">
          <Col style={{ color: "white", marginLeft: "19%" }}>
            new user ?{" "}
            <Link style={{ color: "white" }} to="/register">
              Register
            </Link>
          </Col>
        </Row>
      </FormContainer>
    </div>
  );
};

export default FoodAppLoginScreen;
